import React, { useEffect, useState } from 'react'
import { motion } from 'framer-motion'
import BannerAppComponent from '../molecules/BannerAppComponent/BannerAppComponent'
import AppsFaq from '../molecules/AppsFaq/AppsFaq'
import ReliabilityAppsSupportSteps from '../molecules/AppsSupportComponents/ReliabilityAppsSupportSteps/ReliabilityAppsSupportSteps'
import AppsRunning from '../molecules/AppsSupportComponents/AppsRunning/AppsRunning'
import DefaultFooter from '../organisms/DefaultFooter/DefaultFooter'
import AppsMaintenance from '../molecules/AppsSupportComponents/AppsMaintenance/AppsMaintenance'
import { getPageData, useData } from '../../app/helper/functions'

const AppSupportPage = () => {
    const { data } = useData();
    const appSupportData = getPageData(data, 'appSupportPage');
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <div className='overflow-x-hidden'>
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.8 }}
            >
                <BannerAppComponent
                    bgImage='bg-appSupport-bg'
                    title={appSupportData.title}
                    description={appSupportData.description} />
            </motion.div>
            <div className='bg-darkGreyPrimary'>
                <motion.div
                    initial={{ opacity: 0.6, y: 0 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ amount: 0.3 }}
                    transition={{ duration: 0.2, ease: "easeOut", delay: 0.1 }}
                    className="px-2 sm:px-4 md:px-6"
                >
                    <ReliabilityAppsSupportSteps appSupportData={appSupportData} />
                </motion.div>
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ amount: 0.3 }}
                    transition={{ duration: 0.6, ease: "easeOut", delay: 0.1 }}
                    className="mt-4 sm:mt-8 md:mt-12"
                >
                    <AppsRunning
                        bgImage='bg-confident-center-bg'
                        title='Keep your app running at its best'
                        subtitle="Reach out for a free consultation today, and we'll recommend the best maintenance strategy for your business."
                    />
                </motion.div>
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ amount: 0.3 }}
                    transition={{ duration: 0.6, ease: "easeOut", delay: 0.1 }}
                    className="mt-6 sm:mt-10 md:mt-16"
                >
                    <AppsFaq />
                </motion.div>
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ amount: 0.3 }}
                    transition={{ duration: 0.6, ease: "easeOut", delay: 0.1 }}
                    className="mt-6 sm:mt-10 md:mt-16"
                >
                    <AppsMaintenance
                        bgImage='bg-maintenance-service-bg'
                        title='Advantages of our maintenance service'
                        subtitle="With our maintenance service, your app is secure and always updated. We offer flexible plans, reliable help, and fast resolutions, allowing you to focus on your business without any technical worries."
                    />
                </motion.div>
                <DefaultFooter />
            </div>
        </div>
    )
}

export default AppSupportPage
